/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import {
  Modal,
  Dropdown,
  Icon,
  Label,
  Loader,
  Message,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import axios from 'axios';
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import Update from 'immutability-helper';
import ClarLoader from '../../Loader/Loader';
import api from '../../../api';
import closeBtn from '../../../images/components/new_scan/close-btn.svg';
import progress from '../../../images/icons/progress_ica.gif';
import search from '../../../images/components/left_menu/searchIcon.png';
import foldImg from '../../../images/components/left_menu/foldIcon.png';
import expandImg from '../../../images/components/left_menu/expandIcon.png';
import bulletImg from '../../../images/components/left_menu/bullet.png';
import CreateProjectModal from '../../Modal/CreateProjectModal';
import AddVersionModal from '../../Modal/AddVersionModal';
import ScanningFile from './ImportingFile';
import { convertPropertiesToCamelCase } from '../../../utils/shared';
import WithRouter from '../../Extensions/WithRouter';

const ONE_DAY = 24 * 60 * 60 * 1000; // hr * min * sec * ms
const WAIT = ONE_DAY;

class ImportPopup extends Component {
  constructor(props) {
    super(props);
    this.updateInterval = null;
    this.updateTokenInterval = null;
    this.modalBody = null;
    this.dropzoneMsg = null;
    this.smallBody = null;
    this.cancelToken = [];
    this.fileInputRef = React.createRef();
    this.state = {
      isOpenImport: props.isOpenImport,
      isOpenMCP: false,
      isOpenMAV: false,
      isOpenWarnDisk: false,
      isLoading: false,
      isLoadingTree: false,
      isOpenWarnModal: false,
      isStartScan: false,
      modalWithError: false,
      isAllowShowQuota: false,
      licenseRegistered: false,
      licenseCurrent: false,
      errSearch: false,
      isWarnModalLoader: false,
      isWarModalError: false,
      quotaResult: [],
      activeIndex: [],
      projectList: [],
      scanningStatus: [],
      selectedIndex: '',
      selectedProject: '',
      selectedProjectNm: '',
      selectedVersion: '',
      selectedVersionNm: '',
      selectedColumn: 'uploaded',
      searchKeyword: '',
      targetName: '',
      targetId: '',
      usertimeStamp: localStorage.getItem('modal-timestamp'),
      parentId: '',
      isDroppable: true,
      fileURL: '',
      refreshInterval: 1000 * 60 * 5,
    };
    this.validateQuota = this.validateQuota.bind(this);
    this.toggleRow = this.toggleRow.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleMCPClose = this.handleMCPClose.bind(this);
    this.handleMAVClose = this.handleMAVClose.bind(this);
    this.handleCreateCallback = this.handleCreateCallback.bind(this);
    this.handleAddCallback = this.handleAddCallback.bind(this);
    this.handleSortingChange = this.handleSortingChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.stopFileUploading = this.stopFileUploading.bind(this);
    this.isAlreadyExisted = this.isAlreadyExisted.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.createProject = this.createProject.bind(this);
    this.addVersion = this.addVersion.bind(this);
    this.deleteCallback = this.deleteCallback.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.closeWarnModal = this.closeWarnModal.bind(this);
    this.closeNewScanModal = this.closeNewScanModal.bind(this);
    this.closeDiskModal = this.closeDiskModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.initUploadingList = this.initUploadingList.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleFileUploadClick = this.handleFileUploadClick.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.new_scan_popup .drop_files .file_info span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.new_scan_popup .scanning_files_wrap .scanning_files .scanning_files_table span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      licenseRegistered, licenseCurrent, warnLevel, isLoading, scanningStatus
    } = this.state;
    const { state, isOpenImport } = this.props;
    if ((prevState.isLoading !== isLoading) && !isLoading) {
      if (!licenseRegistered || !licenseCurrent || warnLevel === 'forbidden') {
        return;
      }
      this.getProjectTree('findSelectedRow');
    }

    if (prevState.scanningStatus.length !== scanningStatus.length && scanningStatus.length === 0) {
      this.onUpdateStop();
      this.onUpdateTokenStop();
      state.report.setScanningCount(0);
      state.report.initScanningData();
    }

    if (prevProps.isOpenImport !== isOpenImport) {
      if (!isOpenImport) {
        this.onUpdateStop();
        this.onUpdateTokenStop();
      }
    }
    if (prevProps.isOpenImport !== isOpenImport) {
      state.report.syncNewScanModal(isOpenImport);
      state.report.initScanningData();
      this.modalBody = null;
      this.smallBody = null;
      this.dropzoneMsg = null;
      this.updateTokenInterval = null;
      this.setState({
        isOpenImport,
        searchKeyword: '',
        selectedColumn: 'uploaded',
        isDroppable: true,
        scanningStatus: [],
        isStartScan: false,
        isLoadingTree: false,
        selectedIndex: '',
        selectedProject: '',
        selectedProjectNm: '',
        selectedVersion: '',
        selectedVersionNm: '',
        fileURL: '',
        isOpenWarnModal: false,
        projectList: [],
        activeIndex: [],
        isWarnModalLoader: false,
        isWarModalError: false,
        modalWithError: false,
      }, () => {
        if (isOpenImport) {
          this.getScanList();
        }
      });
    }
  }

  handleAddCallback(res) {
    const { projectList, targetId } = this.state;
    const findSelectedIndex = projectList.findIndex((item) => {
      return item.data.id === targetId;
    });

    this.setState({
      isOpenMAV: false,
      selectedVersion: res.id,
      selectedVersionNm: res.name,
    }, () => {
      this.getProjectVersionTree(findSelectedIndex, 'addVersion');
    });
  }

  handleSortingChange(e, data) {
    const { selectedColumn } = this.state;
    if (data.value === selectedColumn) {
      return;
    }
    this.setState(
      {
        selectedColumn: data.value,
        projectList: [],
        activeIndex: [],
        selectedIndex: [],
      },
      () => {
        this.getProjectTree();
      }
    );
  }

  handleToggle = (e, index) => {
    const { translate } = this.props;
    const {
      selectedIndex, projectList, licenseRegistered, licenseCurrent, isStartScan
    } = this.state;

    if (e.target.tagName === 'IMG' && (e.target.classList.contains('fold_icon') || e.target.classList.contains('expand_icon'))) {
      return null;
    }

    if (selectedIndex === index) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_project_verion');
      this.setState({
        selectedIndex: '',
        selectedProject: '',
        selectedProjectNm: '',
        selectedVersion: '',
        selectedVersionNm: '',
        isDroppable: false,
      });
      return null;
    }

    if (typeof index === 'string') {
      const stringValue = index.split('-');
      if (licenseRegistered && licenseCurrent && isStartScan) {
        this.setState({
          selectedIndex: index,
          selectedProject: projectList[Number(stringValue[0])].data.target_id.project_id,
          selectedProjectNm: projectList[Number(stringValue[0])].data.name,
          selectedVersion: projectList[Number(stringValue[0])].children[Number(stringValue[1])].data.target_id.project_version_id,
          selectedVersionNm: projectList[Number(stringValue[0])].children[Number(stringValue[1])].data.name,
          isDroppable: true,
        });
      } else {
        this.setState({
          selectedIndex: index,
          selectedProject: projectList[Number(stringValue[0])].data.target_id.project_id,
          selectedProjectNm: projectList[Number(stringValue[0])].data.name,
          selectedVersion: projectList[Number(stringValue[0])].children[Number(stringValue[1])].data.target_id.project_version_id,
          selectedVersionNm: projectList[Number(stringValue[0])].children[Number(stringValue[1])].data.name,
        });
      }
    }
  };

  handleMCPClose() {
    this.setState({
      isOpenMCP: false,
    });
  }

  handleMAVClose() {
    this.setState({
      isOpenMAV: false,
    });
  }

  handleCreateCallback(res) {
    this.setState({
      isOpenMCP: false,
      selectedProject: res.id,
      selectedProjectNm: res.name,
      projectList: [],
    }, () => {
      this.getProjectTree('createProject');
    });
  }

  onUpdateStart() {
    this.updateInterval = null;
    if (!this.onUpdateRunning()) {
      this.updateInterval = setInterval(() => {
        this.onUpdateCheck();
      }, 10000);
    }
  }

  onUpdateStop() {
    clearInterval(this.updateInterval);
    this.updateInterval = null;
  }

  onUpdateRunning() {
    return this.updateInterval !== null;
  }

  onUpdateTokenStart() {
    const { refreshInterval } = this.state;
    this.updateTokenInterval = null;
    if (!this.onUpdateTokenRunning()) {
      this.updateTokenInterval = setInterval(() => {
        this.getExtendToken();
      }, refreshInterval);
    }
  }

  onUpdateTokenStop() {
    clearInterval(this.updateTokenInterval);
    this.updateTokenInterval = null;
  }

  onUpdateTokenRunning() {
    return this.updateTokenInterval !== null;
  }

  onUpdateActiveProject(string, project, projectVersion) {
    const { scanningStatus } = this.state;
    if (scanningStatus.length === 0) {
      return;
    }

    if (string === 'project') {
      const activeProjectArray = scanningStatus.filter((item) => {
        return item.project_id === project.data.target_id.project_id;
      });

      if (activeProjectArray.length !== 0) {
        return (
          <p style={{ margin: '0' }}>
            <img
              src={progress}
              role="presentation"
              alt=""
              style={{
                width: 15,
                height: 15,
                margin: '3.2px 0 0 5px',
                verticalAlign: 'middle',
              }}
            />
          </p>
        );
      }
    }

    if (string === 'version') {
      const activeProjectVersionArray = scanningStatus.filter((item) => {
        return item.project_id === project.data.target_id.project_id && item.project_version_id === projectVersion.data.target_id.project_version_id;
      });

      if (activeProjectVersionArray.length !== 0) {
        return (
          <p style={{ margin: '0' }}>
            <img
              src={progress}
              role="presentation"
              alt=""
              style={{
                width: 15,
                height: 15,
                margin: '3.2px 0 0 5px',
                verticalAlign: 'middle',
              }}
            />
          </p>
        );
      }
    }
  }

  onDrop(files) {
    const { state } = this.props;
    this.onUpdateStop();
    const {
      uploadingProgressArray
    } = state.report;
    const {
      selectedProject,
      selectedVersion,
      selectedProjectNm,
      selectedVersionNm
    } = this.state;
    const customIds = [];
    const sliced = uploadingProgressArray.slice();

    if (!this.validateForm()) {
      return null;
    }

    const existIds = sliced.map((item) => {
      return item.frontId;
    });

    if (existIds.length === 0) {
      while (customIds.length < files.length) {
        const r = uuidv4();
        customIds.push(r);
      }
    } else {
      while (customIds.length < files.length) {
        const r = uuidv4();
        if (existIds.indexOf(r) === -1) {
          customIds.push(r);
        }
      }
    }

    try {
      const fileData = files.map((file, index) => {
        const formData = new FormData();
        formData.append('sbom', file);
        formData.append('selected_project_id', selectedProject);
        formData.append('selected_project_version_id', selectedVersion);
        formData.append('front_id', customIds[index]);

        const newData = {
          project_id: selectedProject,
          project_version_id: selectedVersion,
          name: file.name,
          project_name: selectedProjectNm,
          project_version_name: selectedVersionNm,
          scan_status: 5,
          scan_status_detail: 'Uploading',
          scan_progress: 0,
          uploaded_size: this.byteToSize(file.size),
          has_manage_permission: true,
          front_id: customIds[index],
          type: 'local',
        };

        const obj = {
          front_id: customIds[index],
          status: 'upload',
        };

        state.report.updateProgressArray(1, newData.front_id, 'local');
        state.report.setScanning(obj);

        const newfiles = {
          formData,
          newData,
        };

        return newfiles;
      });

      this.setState((prevState) => {
        return {
          scanningStatus: [
            ...prevState.scanningStatus,
            ...fileData.map((file) => { return file.newData; }),
          ]
        };
      }, () => {
        this.sbomImport(fileData);
      });
    } catch (err) {
      console.error('Error processing files:', err);
    }
  }

  onUpdateCheck() {
    const { state } = this.props;
    const { scanningData } = state.report;
    const { scanningStatus, isAllowShowQuota, quotaResult } = this.state;
    const storeScanningData = scanningData.slice();
    const cloneScanningStatus = [...scanningStatus];
    let scanningIds = [];

    //scanningArray
    //scanning
    //queue
    //uploading url
    //preparing url upload

    if (cloneScanningStatus.length === 0) {
      return this.onUpdateTokenStop();
    }

    scanningIds = storeScanningData.map((item) => {
      return item.front_id;
    });

    const obj = {
      page: 1,
      limit: '',
      front_ids: scanningIds,
    };

    api
      .getNewScanUpdateCheck(obj)
      .then((response) => {
        const data = convertPropertiesToCamelCase(response.data.response);
        if (!this.validateQuota(data)) {
          return;
        }

        let newState;
        let updatedResponse;
        let i = 0;

        scanningIds.map((frontId) => {
          const updatedResponseIndex = data.scanningStatus.findIndex((item) => {
            return item.front_id === frontId;
          });

          if (updatedResponseIndex === -1) {
            //scanning status === 6 ? check front_id in data.scanningStatus
            //file.type && file.scan_status === 5 && //uploading progress update with local
            const uploadingLocalStatusArray = cloneScanningStatus.filter((item) => {
              return item.type && item.scan_status === 5;
            });
            const uploadingUrlStatusArray = cloneScanningStatus.filter((item) => {
              return item.scan_status === 6;
            });

            if (uploadingLocalStatusArray.length !== 0) {
              return false; //local uploading
            }
            if (uploadingUrlStatusArray.length !== 0) {
              return false; //url prepare uploading
            }

            const currentIndex = cloneScanningStatus.findIndex((item) => {
              return item.front_id === frontId;
            });

            if (currentIndex === -1) {
              return console.log('Invalid case');
            }

            //scan complete
            const storeObject = {
              front_id: frontId,
              status: 'complete',
            };
            state.report.removeScanning(storeObject);

            //remove scanning row
            newState = cloneScanningStatus.filter((item) => {
              return item.front_id !== frontId;
            });

            return this.setState({
              scanningStatus: newState,
            });
          }

          const updatedStateIndex = cloneScanningStatus.findIndex((item) => {
            return item.front_id === frontId;
          });

          if (updatedStateIndex === -1) {
            const storeObject = {
              front_id: frontId,
              status: 'Invalid',
            };
            state.report.removeScanning(storeObject);
            return console.log('Invalid state case');
          }

          if (
            (data.scanningStatus[updatedResponseIndex].scan_status !== cloneScanningStatus[updatedStateIndex].scan_status) //scan_status
            || (data.scanningStatus[updatedResponseIndex].uploaded_progress !== cloneScanningStatus[updatedStateIndex].uploaded_progress) //uploaded_progress
            || (data.scanningStatus[updatedResponseIndex].scan_progress !== cloneScanningStatus[updatedStateIndex].scan_progress) //scan_progrss
            || (data.scanningStatus[updatedResponseIndex].scan_status_detail !== cloneScanningStatus[updatedStateIndex].scan_status_detail) // scan_status_detail
          ) {
            if (i === 0) {
              updatedResponse = Update(cloneScanningStatus[updatedStateIndex], { $set: data.scanningStatus[updatedResponseIndex] });
              newState = Update(cloneScanningStatus, {
                $splice: [[updatedStateIndex, 1, updatedResponse]],
              });
              i++;
            } else {
              updatedResponse = Update(newState[updatedStateIndex], { $set: data.scanningStatus[updatedResponseIndex] });
              newState = Update(newState, {
                $splice: [[updatedStateIndex, 1, updatedResponse]],
              });
              i++;
            }
            //value {front_id, status} // status: 'upload', 'scanning', 'complete'

            if (data.scanningStatus[updatedResponseIndex].scan_status === 0
              || data.scanningStatus[updatedResponseIndex].scan_status === 1) {
              const storeObject = {
                front_id: frontId,
                status: 'scanning',
              };
              state.report.setScanning(storeObject);
            }

            if (data.scanningStatus[updatedResponseIndex].scan_status === 5) {
              const storeObject = {
                front_id: frontId,
                status: 'upload',
              };
              state.report.setScanning(storeObject);
            }
            return this.setState({
              scanningStatus: newState,
            });
          }
          return newState;
        });

        state.report.setScanningCount(scanningStatus.length);

        if (isAllowShowQuota !== data.quota.allow_show_quota) {
          this.setState({
            isAllowShowQuota: data.quota.allow_show_quota,
          });
        }

        if (quotaResult[0].spent !== data.quota.quota_result[0].spent
          || quotaResult[0].capacity !== data.quota.quota_result[0].capacity
          || quotaResult[0].type !== data.quota.quota_result[0].type) {
          this.setState({
            quotaResult: data.quota.quota_result,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
          isLoadingTree: false,
        });
      });
  }

  handleSearch = (event) => {
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
              });
            }, 1500);
          }
        );
        return false;
      }
      this.setState(
        {
          searchKeyword: event.target.value,
          projectList: [],
          activeIndex: [],
          selectedIndex: [],
        },
        () => {
          this.getProjectTree('search');
        }
      );
    }
  };

  getProjectTree = (callback) => {
    const { translate } = this.props;
    const {
      licenseRegistered,
      licenseCurrent,
      searchKeyword,
      selectedColumn,
      selectedProject,
    } = this.state;
    if (callback === 'createProject') {
      this.setState({
        isLoadingTree: true,
      }, () => {
        api.getProjectVersionTree(
          {
            search: '',
            target_object: 'project',
            page: 1,
            order: selectedColumn,
          }
        )
          .then((response) => {
            const projectList = response.response.map((item) => {
              return {
                data: item,
                children: [],
              };
            });
            const findSelectedIndex = projectList.findIndex((item) => {
              return item.data.id === selectedProject;
            });
            this.search.value = '';

            if (findSelectedIndex === -1) {
              console.log('cannot find project list');
              return this.setState({
                isLoadingTree: false,
                searchKeyword: '',
                projectList,
              });
            }

            if (licenseRegistered && licenseCurrent) {
              this.setState({
                isLoadingTree: false,
                isDroppable: true,
                projectList,
                searchKeyword: '',
              }, () => {
                this.findSelectedRow({ projectIndex: findSelectedIndex, target: callback });
              });
            } else {
              this.setState({
                isLoadingTree: false,
                searchKeyword: '',
                projectList,
              }, () => {
                this.findSelectedRow({ projectIndex: findSelectedIndex, target: callback });
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingTree: false,
            });
          });
      });
    } else {
      this.setState({
        isLoadingTree: true,
      }, () => {
        api.getProjectVersionTree(
          {
            search: searchKeyword,
            target_object: 'project',
            page: 1,
            order: selectedColumn,
          }
        )
          .then((response) => {
            const projectList = response.response.map((item) => {
              return {
                data: item,
                children: [],
              };
            });

            if (callback === 'findSelectedRow') {
              const findSelectedIndex = projectList.findIndex((item) => {
                return item.data.selected === true;
              });

              if (findSelectedIndex === -1) {
                this.dropzoneMsg = translate('modal.new_scan.message.warn_project_verion');
                if (projectList.length === 0) {
                  return this.setState({
                    isLoadingTree: false,
                    projectList,
                    isDroppable: false,
                  }, () => {
                    this.createProject();
                  });
                }

                return this.setState({
                  isLoadingTree: false,
                  projectList,
                  isDroppable: false,
                });
              }

              this.setState({
                isLoadingTree: false,
                isDroppable: true,
                projectList,
              }, () => {
                this.findSelectedRow({ projectIndex: findSelectedIndex, target: callback });
              });
            } else if (callback === 'search') {
              if (projectList.length === 0) {
                return this.setState({
                  isDroppable: false,
                  isLoadingTree: false,
                  projectList,
                });
              }
              const findSelectedIndex = projectList.findIndex((item) => {
                return item.data.selected === true;
              });
              if (findSelectedIndex === -1) {
                this.dropzoneMsg = translate('modal.new_scan.message.warn_project_verion');
                return this.setState({
                  isLoadingTree: false,
                  projectList,
                  isDroppable: false,
                });
              }
              return this.setState({
                isLoadingTree: false,
                isDroppable: true,
                projectList,
              }, () => {
                this.findSelectedRow({ projectIndex: findSelectedIndex, target: 'findSelectedRow' });
              });
            } else {
              this.dropzoneMsg = translate('modal.new_scan.message.warn_project_verion');
              this.setState({
                isLoadingTree: false,
                //totalCount: response.count,
                projectList,
                isDroppable: false,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoadingTree: false,
            });
          });
      });
    }
  };

  getProjectVersionTree = (parentIndex, callback) => {
    const {
      projectList, parentId, searchKeyword, selectedVersion
    } = this.state;

    if (callback === 'createProject' || callback === 'addVersion') {
      api.getProjectVersionTree(
        {
          search: '',
          target_object: 'project_version',
          object_parent_id: parentId,
          page: 1,
        }
      )
        .then((response) => {
          const projectVersionList = response.response.map((item) => {
            return {
              data: item,
              children: [],
            };
          });

          if (callback === 'createProject') {
            this.search.value = '';
            this.setState({
              projectList: Update(projectList, {
                [parentIndex]: {
                  children: {
                    $push: projectVersionList,
                  },
                },
              }),
              searchKeyword: '',
            }, () => {
              this.findSelectedRow({ projectIndex: parentIndex, versionIndex: 0 });
            });
          } else if (callback === 'addVersion') {
            this.search.value = '';
            const selectedRow = projectVersionList.findIndex((item) => {
              return item.data.id === selectedVersion;
            });

            this.setState({
              projectList: Update(projectList, {
                [parentIndex]: {
                  children: {
                    $set: projectVersionList,
                  },
                },
              }),
              searchKeyword: '',
              isDroppable: true,
            }, () => {
              this.findSelectedRow({ projectIndex: parentIndex, versionIndex: selectedRow });
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoadingTree: false,
          });
        });
    } else {
      api.getProjectVersionTree(
        {
          search: searchKeyword,
          target_object: 'project_version',
          object_parent_id: parentId,
          page: 1,
        }
      )
        .then((response) => {
          const projectVersionList = response.response.map((item) => {
            return {
              data: item,
              children: [],
            };
          });

          if (callback === 'findSelectedRow') {
            const selectedRow = projectVersionList.findIndex((item) => {
              return item.data.selected === true;
            });

            if (selectedRow === -1) {
              this.setState({
                projectList: Update(projectList, {
                  [parentIndex]: {
                    children: {
                      $push: projectVersionList,
                    },
                  },
                }),
              });
            } else {
              this.setState({
                projectList: Update(projectList, {
                  [parentIndex]: {
                    children: {
                      $push: projectVersionList,
                    },
                  },
                }),
              }, () => {
                this.findSelectedRow({ projectIndex: parentIndex, versionIndex: selectedRow });
              });
            }
          } else {
            this.setState({
              projectList: Update(projectList, {
                [parentIndex]: {
                  children: {
                    $push: projectVersionList,
                  },
                },
              }),
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoadingTree: false,
          });
        });
    }
  };

  getScanList() {
    const obj = {
      page: 1,
      limit: '',
    };
    const { usertimeStamp } = this.state;
    const { translate } = this.props;

    this.setState({
      isLoading: true,
    }, () => {
      api
        .getScanList(obj)
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);
          if (!data.licenseRegistered) {
            this.dropzoneMsg = translate('modal.new_scan.message.warn_register_company');
            return this.setState({
              licenseRegistered: data.licenseRegistered,
              isLoading: false,
              isDroppable: false,
            });
          }
          if (data.licenseRegistered && !data.licenseCurrent) {
            this.dropzoneMsg = translate('modal.new_scan.message.warn_expired_license');
            return this.setState({
              licenseRegistered: data.licenseRegistered,
              licenseCurrent: data.licenseCurrent,
              isLoading: false,
              isDroppable: false,
            });
          }

          if (data.remainDisk.warn_level === 'forbidden' && data.licenseRegistered && data.licenseCurrent) {
            this.dropzoneMsg = translate('modal.new_scan.message.warn_forbidden_disk_space');
            return this.setState({
              isLoading: false,
              isDroppable: false,
              licenseRegistered: data.licenseRegistered,
              licenseCurrent: data.licenseCurrent,
              warnLevel: data.remainDisk.warn_level,
            });
          }

          if (data.remainDisk.warn_level === 'warn' && data.licenseRegistered && data.licenseCurrent && this.timeExpired(usertimeStamp)) {
            localStorage.setItem('modal-timestamp', Date.now());
            this.modalBody = translate('modal.new_scan.message.warn_disk_space');
            this.setState({
              isOpenWarnDisk: true,
              usertimeStamp: Date.now(),
              warnLevel: data.remainDisk.warn_level,
            });
          }

          if (data.licenseRegistered && data.licenseCurrent && data.remainDisk.warn_level !== 'forbidden') {
            this.setState({
              isStartScan: true,
            });
          }

          this.setState({
            isLoading: false,
            licenseRegistered: data.licenseRegistered,
            licenseCurrent: data.licenseCurrent,
            isAllowShowQuota: data.quota.allow_show_quota,
            quotaResult: data.quota.quota_result,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  getExtendToken = () => {
    api
      .getExtendToken()
      .then()
      .catch((err) => {
        console.log(err);
      });
  };
  /*
  parseUploadedFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const jsonData = JSON.parse(e.target.result);
          resolve(jsonData);
        } catch (error) {
          reject(new Error('Invalid JSON format'));
        }
      };

      reader.onerror = () => {
        reject(new Error('Error reading file'));
      };

      reader.readAsText(file);
    });
  };

  processFiles = async (files) => {
    const fileData = await Promise.all(
      files.map(async (file) => {
        try {
          const jsonData = await this.parseUploadedFile(file);
          return { file, jsonData };
        } catch (error) {
          console.error('Error parsing file:', error);
          return null;
        }
      })
    );
    return fileData;
  };
  */

  sbomImport = (fileData) => {
    const { state, translate } = this.props;
    const { selectedProjectNm, selectedVersionNm } = this.state;
    this.onUpdateTokenStart();
    const upLoaders = fileData.map((file) => {
      const fnUploadProgress = (myFileid) => {
        return (progressEvent) => {
          const percentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          state.report.updateProgressArray(percentage, myFileid, 'local');
        };
      };

      const { CancelToken } = axios;
      const source = CancelToken.source();

      const newSource = {
        front_id: file.newData.front_id,
        source,
      };

      this.cancelToken.push(newSource);

      return (
        api
          .sbomImport(file.formData, fnUploadProgress(file.newData.front_id), source.token)
          .then((response) => {
            const data = response.response;
            console.log(data);
            const newData = {
              uploaded_file_id: data.uploaded_file_id,
              front_id: data.front_id,
              project_id: data.project_id,
              project_version_id: data.project_version_id,
              name: data.name,
              project_name: selectedProjectNm,
              project_version_name: selectedVersionNm,
              scan_status: data.scan_status,
              scan_status_detail: data.scan_status_detail,
              scan_progress: 0,
              uploaded_size: file.newData.uploaded_size,
              has_manage_permission: data.has_manage_permission,
            };

            const obj = {
              front_id: data.front_id,
              status: 'scanning',
            };

            state.report.addFrontId(data.front_id);
            state.report.updateProgressArray(100, file.newData.front_id, 'local');
            state.report.setScanning(obj);
            state.report.setReload();

            this.setState((prevState) => {
              const currentIndex = prevState.scanningStatus.findIndex((item) => { return item.front_id === file.newData.front_id; });

              if (currentIndex === -1) {
                return null;
              }

              const newStatusArray = [...prevState.scanningStatus];
              newStatusArray[currentIndex] = newData;

              return { scanningStatus: newStatusArray };
            });
          })
          .catch((err) => {
            console.log(err);
            if (axios.isCancel(err)) {
              console.log('Request canceled', err.message);
            } else {
              const o = err?.data?.response;

              if (err.status === '413' || err.status === 413) {
                this.modalBody = err.statusText;
                this.setState((prevState) => {
                  const newStatusArray = prevState.scanningStatus.filter((item) => {
                    return item.front_id !== file.newData.front_id;
                  });
                  return {
                    modalWithError: true,
                    scanningStatus: newStatusArray,
                  };
                });

                state.report.updateProgressArray(0, file.newData.front_id, 'local');
                return;
              }

              if (!o || !o.error) {
                this.modalBody = translate('modal.new_scan.error.error_unknown');
              } else {
                switch (o.error) {
                case '422-653':
                  this.modalBody = translate('modal.new_scan.error.error_422_653');
                  break;
                case '422-366':
                  this.modalBody = o.error_description;
                  this.stopFileUploading(file.newData.name, file.newData.front_id);
                  break;
                case '500-366':
                  this.modalBody = o.error_description;
                  break;
                default:
                  this.modalBody = o.error_description || translate('modal.new_scan.error.error_unknown');
                  break;
                }
              }
            }

            this.setState((prevState) => {
              const newStatusArray = prevState.scanningStatus.filter((item) => { return item.front_id !== file.newData.front_id; });
              return {
                modalWithError: true,
                scanningStatus: newStatusArray,
              };
            });

            if (this.fileInputRef.current) {
              this.fileInputRef.current.value = '';
            }
            state.report.updateProgressArray(0, file.newData.front_id, 'local', 'error');
          })
      );
    });

    axios.all(upLoaders)
      .then(() => {
        this.onUpdateStart();
        if (this.fileInputRef.current) {
          this.fileInputRef.current.value = '';
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log('Request canceled', err.message);
        } else {
          // handle error
          console.log(err);
        }
      });
  };

  findSelectedRow = (obj) => {
    const { projectList, isStartScan } = this.state;
    const data = obj;

    if (data.target) {
      const parentId = projectList[data.projectIndex].data.target_id.project_id;
      return this.setState({
        activeIndex: [data.projectIndex],
        parentId,
      }, () => {
        this.getProjectVersionTree(data.projectIndex, data.target);
      });
    }

    if (isStartScan) {
      return this.setState({
        selectedIndex: `${data.projectIndex}-${data.versionIndex}`,
        selectedProject: projectList[data.projectIndex].data.target_id.project_id,
        selectedProjectNm: projectList[data.projectIndex].data.name,
        selectedVersion: projectList[data.projectIndex].children[data.versionIndex].data.target_id.project_version_id,
        selectedVersionNm: projectList[data.projectIndex].children[data.versionIndex].data.name,
      });
    }
    return this.setState({
      isDroppable: false,
      selectedIndex: `${data.projectIndex}-${data.versionIndex}`,
      selectedProject: projectList[data.projectIndex].data.target_id.project_id,
      selectedProjectNm: projectList[data.projectIndex].data.name,
      selectedVersion: projectList[data.projectIndex].children[data.versionIndex].data.target_id.project_version_id,
      selectedVersionNm: projectList[data.projectIndex].children[data.versionIndex].data.name,
    });
  };

  timeExpired = (timestamp) => {
    if (!timestamp || Date.now() - timestamp > WAIT) {
      return true;
    }
  };

  toggleRow = (index, targetId) => {
    const { activeIndex, projectList, selectedIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });

      if (typeof selectedIndex === 'number' && Number(selectedIndex) === index) {
        this.setState({
          selectedIndex: '',
          selectedProject: '',
          selectedProjectNm: '',
        });
      } else if (typeof selectedIndex === 'string') {
        const stringValue = selectedIndex.split('-');
        if (Number(stringValue[0]) === index) {
          this.setState({
            selectedIndex: '',
            selectedProject: '',
            selectedProjectNm: '',
            selectedVersion: '',
            selectedVersionNm: '',
          });
        }
      }

      this.setState({
        projectList: Update(projectList, {
          [index]: {
            children: {
              $set: [],
            },
          },
        },),
        activeIndex: newState,
      });
    } else {
      newState = [...activeIndex, index];
      this.setState({
        activeIndex: newState,
        parentId: targetId,
      }, () => {
        this.getProjectVersionTree(index);
      });
    }

  };

  handleFileUploadClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    this.onDrop(files);
  };

  handleDrop = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const files = Array.from(event.dataTransfer.files);
    this.onDrop(files);
  };

  stopFileUploading = (name, id) => {
    const { scanningStatus } = this.state;
    const { state } = this.props;
    const selectedArray = this.cancelToken.filter((item) => {
      return item.front_id === id;
    });

    const newState = scanningStatus.filter((item) => {
      return item.front_id !== id;
    });

    const obj = {
      front_id: id,
      status: 'uploading',
    };

    selectedArray[0].source.cancel();
    state.report.removeScanning(obj);

    this.setState({
      scanningStatus: newState,
    });
  };

  createProject = () => {
    this.setState({
      isOpenMCP: true,
    });
  };

  addVersion = (e, projectIndex) => {
    const { projectList } = this.state;

    this.setState({
      isOpenMAV: true,
      targetName: projectList[projectIndex].data.name,
      targetId: projectList[projectIndex].data.target_id.project_id,
    });
  };

  deleteCallback = (data) => {
    const { scanningStatus } = this.state;
    const { state } = this.props;
    const frontId = data.front_id;
    const newData = scanningStatus.filter((item) => {
      return item.front_id !== frontId;
    });

    const obj = {
      front_id: frontId,
    };

    state.report.removeScanning(obj);
    this.setState({
      scanningStatus: newData,
    });
  };

  clearSearch() {
    this.search.value = '';
    this.setState(
      {
        searchKeyword: '',
        projectList: [],
        activeIndex: [],
        selectedIndex: [],
      },
      () => {
        this.getProjectTree('findSelectedRow');
      }
    );
  }

  initUploadingList() {
    const { scanningStatus } = this.state;
    const { state, closeModal, translate } = this.props;

    this.setState({
      isWarnModalLoader: true,
      isWarModalError: false,
    });

    const removeUrlArray = scanningStatus.filter((item) => {
      return !item.type && item.scan_status === 5;
    });

    const removeLocalArray = scanningStatus.filter((item) => {
      return item.scan_status_detail === 'Uploading' || item.scan_status === 6;
    });

    if (removeUrlArray.length !== 0) {
      const urlIds = removeUrlArray.map((item) => {
        return item.front_id;
      });

      urlIds.map(async (item) => {
        const obj = {
          front_id: item,
        };

        const removedObject = await api
          .newScanDelete(obj)
          .then(() => {
            const storeObject = {
              front_id: item,
            };
            state.report.removeScanning(storeObject);
          })
          .catch((err) => {
            console.log(err);
            const o = err.data.response;

            this.modalBody = translate('modal.title.attention');

            if (o.error === '422-206') {
              this.smallBody = translate('modal.new_scan.error.error_422_206');
            }

            if (o.error === '422-021') {
              this.smallBody = translate('modal.new_scan.error.error_422_021');
            }

            if (o.error === '422-366') {
              this.smallBody = o.error_description;
            }

            this.setState({
              isWarModalError: true,
              isWarnModalLoader: false,
            });
          });

        return removedObject;
      });
    }

    if (removeLocalArray.length !== 0) {
      const localIds = removeLocalArray.map((item) => {
        return item.front_id;
      });

      localIds.map(async (item) => {
        const stopFileObject = await this.stopFileUploading('name', item);
        return stopFileObject;
      });
    }

    this.setState({
      isOpenWarnModal: false,
      isWarnModalLoader: false,
      isWarModalError: false,
    }, () => {
      state.report.syncNewScanModal(false);
      closeModal();
    });
  }

  validateQuota(data) {
    const { translate } = this.props;
    const {
      usertimeStamp,
      licenseRegistered,
      licenseCurrent,
      remainDisk,
    } = data;

    if (!licenseRegistered && !licenseCurrent) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_register_company');
      this.setState({
        isDroppable: false,
        licenseRegistered,
        licenseCurrent,
        isStartScan: false,
      });
      return false;
    }

    if (!licenseRegistered && licenseCurrent) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_register_company');
      this.setState({
        isDroppable: false,
        licenseRegistered,
        licenseCurrent,
        isStartScan: false,
      });
      return false;
    }

    if (licenseRegistered && !licenseCurrent) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_expired_license');
      this.setState({
        isDroppable: false,
        licenseRegistered,
        licenseCurrent,
        isStartScan: false,
      });
      return false;
    }

    if (remainDisk.warn_level === 'forbidden' && licenseRegistered && licenseCurrent) {
      this.dropzoneMsg = translate('modal.new_scan.message.warn_forbidden_disk_space');
      this.setState({
        isDroppable: false,
        warnLevel: remainDisk.warn_level,
        licenseRegistered,
        licenseCurrent,
        isStartScan: false,
      });
      return false;
    }

    if (remainDisk.warn_level === 'warn' && licenseRegistered && licenseCurrent && this.timeExpired(usertimeStamp)) {
      localStorage.setItem('modal-timestamp', Date.now());
      this.modalBody = translate('modal.new_scan.message.warn_disk_space');
      this.setState({
        isOpenWarnDisk: true,
        warnLevel: remainDisk.warn_level,
        //usertimeStamp: Date.now(),
        licenseRegistered,
        licenseCurrent,
      });
      return true;
    }
    return true;
  }

  isAlreadyExisted(projectNm) {
    let result = false;
    const { projectList } = this.state;
    const existData = projectList.filter((item) => {
      return item.data.name === projectNm;
    });

    if (existData.length !== 0) {
      result = true;
    }
    return result;
  }

  closeNewScanModal(e) {
    const {
      state,
      closeModal,
    } = this.props;

    if (e.target.classList[0] === 'cancel' || e.target.classList[0] === 'upload') {
      return;
    }
    state.report.syncNewScanModal(false);
    closeModal();
  }

  closeDiskModal() {
    this.setState({
      isOpenWarnDisk: false,
    });
  }

  closeErrorModal() {
    this.setState({
      modalWithError: false,
    });
  }

  closeWarnModal() {
    this.setState({
      isOpenWarnModal: false,
    });
  }

  byteToSize(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
  }

  /*
  checkJsonFileType(jsonData) {
    try {
      if (typeof jsonData !== 'object' || jsonData === null) {
        throw new Error('Invalid JSON format');
      }

      if (jsonData.bomFormat === 'CycloneDX' && jsonData.specVersion) {
        return true;
      }

      if (jsonData.spdxVersion && jsonData.documentNamespace) {
        return true;
      }

      return false;

    } catch (err) {
      console.error(err.message);
      return false;
    }
  }
  */

  validateForm() {
    const {
      selectedProjectNm,
      selectedVersionNm,
    } = this.state;

    const validation = {
      isSelectProject: true,
      isSelectVersion: true,
    };

    if (selectedProjectNm.trim().length === 0) {
      validation.isSelectProject = false;
      return;
    }
    validation.isSelectProject = true;

    if (selectedVersionNm.trim().length === 0) {
      validation.isSelectVersion = false;
      return;
    }
    validation.isSelectVersion = true;

    return (
      validation.isSelectProject
      && validation.isSelectVersion
    );
  }

  render() {
    const {
      activeIndex,
      selectedIndex,
      selectedProjectNm,
      selectedVersionNm,
      projectList,
      selectedColumn,
      scanningStatus,
      isLoading,
      isLoadingTree,
      errSearch,
      licenseRegistered,
      licenseCurrent,
      warnLevel,
      isDroppable,
      isOpenImport,
      fileURL,
      isOpenMCP,
      isOpenMAV,
      targetId,
      targetName,
      isOpenWarnDisk,
      modalWithError,
      isOpenWarnModal,
      isWarnModalLoader,
      isWarModalError,
    } = this.state;

    const { translate } = this.props;

    const sortColumn = [
      { key: 1, text: translate('modal.new_scan.title.newest'), value: 'uploaded' },
      { key: 2, text: translate('modal.new_scan.title.atoz'), value: 'project_r' },
      { key: 3, text: translate('modal.new_scan.title.ztoa'), value: 'project' },
    ];

    return (
      <Modal open={isOpenImport} onClose={this.closeNewScanModal}>
        <div className="new_scan_popup_wrap hide custom_new_scan show">
          <div className="new_scan_popup full_parts">
            <div className="popup_header ">
              <div className="popup_wrap">
                <span className="popup_title">SBOM Import</span>
                <a
                  className="close_button"
                  onClick={this.closeNewScanModal}
                  onKeyUp={this.closeNewScanModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <Message
                info
                size="tiny"
              >
                <Message.Header>
                  {translate('modal.new_scan.message.sbom_import_desc_1')}
                </Message.Header>
                <p>{translate('modal.new_scan.message.sbom_import_desc_2')}</p>
              </Message>
            </div>
            {
              !isLoading ? (
                <div className="popup_contents">
                  <div className="popup_contnet_left_menu">
                    <div className="projects_list_wrap">
                      <div className="projects_search_wrap">
                        <img src={search} alt="" className="search_icon" />
                        <input
                          ref={(ref) => {
                            this.search = ref;
                          }}
                          type="text"
                          className="projects_search"
                          placeholder={translate('modal.new_scan.place_holder.search')}
                          onKeyPress={this.handleSearch}
                          style={{ width: '170px' }}
                        />
                        <a
                          className="reset_icon"
                          onClick={this.clearSearch}
                          onKeyUp={this.clearSearch}
                        >
                          x
                        </a>
                        {errSearch && (
                          <Label basic color="red" pointing>
                            {translate('modal.new_scan.message.least_two_required_to_search')}
                          </Label>
                        )}
                      </div>
                      <div className="projects_list">
                        {
                          !isLoadingTree ? (
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <ul className="depth_1">
                                <li>
                                  {
                                    !licenseRegistered || !licenseCurrent || warnLevel === 'forbidden' ? (
                                      <a className="create disabled">
                                        <p>
                                          <Icon name="add" />
                                          <span>
                                            [
                                            {translate('modal.new_scan.title.new_project')}
                                            ]
                                          </span>
                                        </p>
                                      </a>
                                    ) : (
                                      <a
                                        className="create"
                                        onClick={this.createProject}
                                        onKeyUp={this.createProject}
                                      >
                                        <p>
                                          <Icon name="add" />
                                          <span>
                                            [
                                            {translate('modal.new_scan.title.new_project')}
                                            ]
                                          </span>
                                        </p>
                                      </a>
                                    )
                                  }
                                </li>
                                {
                                  projectList.length !== 0
                                  && projectList.map((project, projectIndex) => {
                                    return (
                                      <li
                                        key={project.data.id.toString()}
                                        className={cx({
                                          expand: activeIndex.indexOf(projectIndex) > -1,
                                        })}
                                      >
                                        <a>
                                          <span
                                            style={{ cursor: 'pointer', margin: '0' }}
                                            onClick={() => {
                                              return this.toggleRow(projectIndex, project.data.target_id.project_id);
                                            }}
                                            onKeyUp={() => {
                                              return this.toggleRow(projectIndex, project.data.target_id.project_id);
                                            }}
                                          >
                                            <img className="fold_icon" src={foldImg} role="presentation" alt="" />
                                            <img
                                              className="expand_icon"
                                              src={expandImg}
                                              role="presentation"
                                              alt=""
                                            />
                                          </span>
                                          <span>
                                            {project.data.name}
                                          </span>
                                          {
                                            this.onUpdateActiveProject('project', project)
                                          }
                                        </a>
                                        <ul className="depth_2">
                                          {project.children.length !== 0
                                            && project.children.map((projectVersion, versionIndex) => {
                                              return (
                                                <li
                                                  key={projectVersion.data.id.toString()}
                                                >
                                                  <a
                                                    className={cx({
                                                      selected:
                                                        selectedIndex === `${projectIndex}-${versionIndex}`,
                                                    })}
                                                    onClick={(e) => {
                                                      return this.handleToggle(e, `${projectIndex}-${versionIndex}`);
                                                    }}
                                                    onKeyUp={(e) => {
                                                      return this.handleToggle(e, `${projectIndex}-${versionIndex}`);
                                                    }}
                                                  >
                                                    <p
                                                      style={{ margin: '0' }}
                                                    >
                                                      <img src={bulletImg} role="presentation" alt="" />
                                                    </p>
                                                    <span>
                                                      {projectVersion.data.name}
                                                    </span>
                                                    {
                                                      this.onUpdateActiveProject('version', project, projectVersion)
                                                    }
                                                  </a>
                                                </li>
                                              );
                                            })}
                                          <li>
                                            <a
                                              className="create"
                                              onClick={(e) => {
                                                return this.addVersion(e, projectIndex);
                                              }}
                                              onKeyUp={(e) => {
                                                return this.addVersion(e, projectIndex);
                                              }}
                                            >
                                              <p>
                                                <Icon name="add" />
                                                <span>
                                                  [
                                                  {translate('modal.new_scan.title.new_version')}
                                                  ]
                                                </span>
                                              </p>
                                            </a>
                                          </li>
                                        </ul>
                                      </li>
                                    );
                                  })
                                }
                              </ul>
                            </Scrollbars>
                          ) : (
                            <Loader active={isLoadingTree} inline="centered" />
                          )
                        }
                      </div>
                      <div className="newest">
                        <Dropdown
                          selection
                          options={sortColumn}
                          value={selectedColumn}
                          //disabled={!isDroppable}
                          onChange={this.handleSortingChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="popup_contnet_right">
                    <div className="drop_files_wrap">
                      <div className="drop_files">
                        <div className="drop_files_wrap">
                          <div className="left">
                            <p className="file_info">
                              <span
                                className={cx(
                                  {
                                    error: !selectedProjectNm,
                                  }
                                )}
                              >
                                {!selectedProjectNm ? null : selectedProjectNm}
                              </span>
                              {!selectedProjectNm ? null : '/'}
                              <span
                                className={cx(
                                  {
                                    error: !selectedVersionNm,
                                  }
                                )}
                              >
                                {!selectedVersionNm ? null : selectedVersionNm}
                              </span>
                            </p>
                          </div>
                          <div className="right">
                            <div className="upload_button_wrap">
                              <a
                                className="button upload"
                                disabled={!isDroppable || !selectedProjectNm || !selectedVersionNm}
                                onClick={this.handleFileUploadClick}
                                onKeyUp={this.handleFileUploadClick}
                              >
                                <Icon name="file" />
                                {translate('modal.new_scan.title.file_type')}
                              </a>
                            </div>
                          </div>
                        </div>
                        {
                          isDroppable ? (
                            <div
                              className="drop_files_here"
                              onDrop={this.handleDrop}
                              onDragOver={(event) => { return event.preventDefault(); }}
                            >
                              <Icon name="cloud upload" size="huge" />
                              <p>{translate('knowledgebase.message.drag_drop_guide')}</p>
                            </div>
                          ) : (
                            <div
                              className="drop_files_here disable"
                            >
                              <Icon name="ban" size="huge" />
                              <p>{this.dropzoneMsg}</p>
                            </div>
                          )
                        }
                        <input
                          type="file"
                          ref={this.fileInputRef}
                          style={{ display: 'none' }}
                          onChange={this.handleFileChange}
                          multiple
                        />
                      </div>
                    </div>
                    <div className="scanning_files_wrap">
                      <div className="popup_contnet_header">
                        <h3>
                          {translate('modal.new_scan.title.imporing_files')}
                          (
                          {scanningStatus.length}
                          )
                        </h3>
                      </div>
                      <div className="scanning_files">
                        <div className="scanning_files_header">
                          <div className="scope_name" style={{ width: '60%' }}>{translate('list.title.file_name')}</div>
                          <div className="scope_name" style={{ width: '40%' }}>{translate('modal.title.status')}</div>
                        </div>
                        <div className="scanning_files_contnet">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                            autoHeight
                            autoHeightMax={265}
                          >
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    {
                                      scanningStatus.length !== 0 ? (
                                        scanningStatus.map((item) => {
                                          return (
                                            <ScanningFile
                                              key={item.front_id}
                                              file={item}
                                              deleteCallback={this.deleteCallback}
                                              stopFileUploading={this.stopFileUploading}
                                              url={fileURL}
                                              translate={translate}
                                            />
                                          );
                                        })
                                      ) : null
                                    }
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Scrollbars>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <ClarLoader />
              )
            }
          </div>
        </div>
        <CreateProjectModal
          isOpenMCP={isOpenMCP}
          closeModal={this.handleMCPClose}
          createCallback={this.handleCreateCallback}
          isAlreadyExisted={this.isAlreadyExisted}
          translate={translate}
        />
        <AddVersionModal
          isOpenMAV={isOpenMAV}
          closeModal={this.handleMAVClose}
          addCallback={this.handleAddCallback}
          projectId={targetId}
          projectNm={targetName}
          translate={translate}
        />
        <Modal
          className="modal"
          open={isOpenWarnDisk}
          onClose={this.closeDiskModal}
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <Scrollbars
                  style={{ height: '200px' }}
                  renderTrackHorizontal={() => {
                    return <div />;
                  }}
                  renderThumbHorizontal={() => {
                    return <div />;
                  }}
                >
                  <p className="text">{this.modalBody}</p>
                </Scrollbars>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeDiskModal}
                    onKeyUp={this.closeDiskModal}
                  >
                    {translate('modal.button.close')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={modalWithError}
          onClose={this.closeErrorModal}
          className="modal"
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{translate('modal.title.notice')}</h2>
                <Scrollbars
                  style={{ height: '200px' }}
                  renderTrackHorizontal={() => {
                    return <div />;
                  }}
                  renderThumbHorizontal={() => {
                    return <div />;
                  }}
                >
                  <p className="text">{this.modalBody}</p>
                </Scrollbars>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeErrorModal}
                    onKeyUp={this.closeErrorModal}
                  >
                    {translate('modal.button.close')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={isOpenWarnModal}
          onClose={this.closeWarnModal}
          className="modal"
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              {
                isWarnModalLoader ? (
                  <ClarLoader />
                ) : (
                  <div className="modal_popup confirm">
                    <h2 className="title">{translate('modal.title.attention')}</h2>
                    <p className="text">{this.modalBody}</p>
                    <p className="small_text">{this.smallBody}</p>
                    {
                      isWarModalError ? (
                        <div className="button_wrap">
                          <a
                            className="center_button"
                            onClick={this.closeWarnModal}
                            onKeyUp={this.closeWarnModal}
                          >
                            {translate('modal.button.close')}
                          </a>
                        </div>
                      ) : (
                        <div className="button_wrap">
                          <a
                            className="left_button"
                            onClick={this.closeWarnModal}
                            onKeyUp={this.closeWarnModal}
                          >
                            {translate('modal.button.cancel')}
                          </a>
                          <a
                            className="right_button"
                            onClick={this.initUploadingList}
                            onKeyUp={this.initUploadingList}
                          >
                            {translate('modal.button.ok')}
                          </a>
                        </div>
                      )
                    }
                  </div>
                )
              }
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(ImportPopup)));
